import React from 'react';
import { Button as RebassButton } from 'rebass';
import Icon, { IconType } from '../Icon/Icon';
import { UtilityButtonProps } from './UtilityButton';

type UtilityIconButtonProps = UtilityButtonProps & {
  /**
   * Icon to be included
   */
  icon?: IconType;
};

export const UtilityIconButton = (
  props: UtilityIconButtonProps
): JSX.Element => {
  const { icon, dark } = props;
  return (
    <RebassButton
      {...props}
      variant={
        dark ? 'utilityIconDark' : props.variant ? props.variant : 'utilityIcon'
      }
    >
      {icon && <Icon pointerEvents="none" icon={icon} size="12" />}
    </RebassButton>
  );
};
